import { render, staticRenderFns } from "./configkasteller.vue?vue&type=template&id=263d959e&scoped=true"
import script from "./configkasteller.vue?vue&type=script&lang=js"
export * from "./configkasteller.vue?vue&type=script&lang=js"
import style0 from "./configkasteller.vue?vue&type=style&index=0&id=263d959e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "263d959e",
  null
  
)

export default component.exports